import { render, staticRenderFns } from "./campusDetails.vue?vue&type=template&id=3c927906&"
import script from "./campusDetails.vue?vue&type=script&lang=js&"
export * from "./campusDetails.vue?vue&type=script&lang=js&"
import style0 from "./campusDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports